export default {
  getTeacherDashboardCount: (state) => state.teacherCount,
};
